@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

/* stylelint-disable css-modules/no-global-scoped-selector */
:root {
  --edit-menu-animation-duration: 320ms;
  --edit-menu-animation-ease: cubic-bezier(0.2, 0.8, 0.2, 1);
}
/* stylelint-enable css-modules/no-global-scoped-selector */

.root {
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
}

.buttons {
  display: flex;
  flex-direction: row;
  gap: 5px;
  width: 100%;
  transition: all var(--edit-menu-animation-duration) var(--edit-menu-animation-ease);
  will-change: transform, opacity;

  &[data-animation-state='animating'] {
    transition: all var(--edit-menu-animation-duration) var(--edit-menu-animation-ease);
  }

  &[data-animation-state='idle'] {
    transition: all 150ms ease-out;
  }

  [data-autopilot-system-redesign='on'] & {
    flex-direction: column;
  }

  > * {
    transition: all var(--edit-menu-animation-duration) var(--edit-menu-animation-ease);
    will-change: transform, opacity;
  }
}

@media (prefers-reduced-motion: reduce) {
  .buttons,
  .buttons > * {
    transition: none !important;
  }
}

.tooltipWrapper {
  > button {
    padding-left: 13px;
    padding-right: 13px;
  }
}
